import { format } from "date-fns";
import { fr } from "date-fns/locale";
import { ReturnCard } from "./ReturnCard";

interface TransactionGridProps {
  transactions: any[];
  isLoading: boolean;
}

export const TransactionGrid = ({ transactions, isLoading }: TransactionGridProps) => {
  if (isLoading) {
    return <div className="text-center p-4">Chargement...</div>;
  }

  if (!transactions || transactions.length === 0) {
    return <div className="text-center p-4 text-gray-500">Aucune transaction trouvée</div>;
  }

  // Group transactions by date
  const groupedTransactions = transactions.reduce((groups: any, transaction: any) => {
    const date = format(new Date(transaction.created_at), 'PP', { locale: fr });
    if (!groups[date]) {
      groups[date] = [];
    }
    groups[date].push(transaction);
    return groups;
  }, {});

  return (
    <div className="space-y-6">
      {Object.entries(groupedTransactions).map(([date, dateTransactions]: [string, any[]]) => (
        <div key={date} className="space-y-4">
          <h3 className="text-sm md:text-base font-medium text-gray-500">{date}</h3>
          <div className="grid gap-4 md:grid-cols-2 lg:grid-cols-3">
            {dateTransactions.map((transaction: any) => (
              <ReturnCard key={transaction.id} transaction={transaction} />
            ))}
          </div>
        </div>
      ))}
    </div>
  );
};